import './styling.scss';
import * as template from './template.html';

import * as angular from 'angular';
import * as componentsModule from './components';

const module = angular.module('messages-page', [componentsModule.module.name]);

interface MessagesPageController extends angular.IStrictController {
    policyIndex: RoutePolicyIndex;
    policyInfo: CustomerPolicyInfo;
}

module.component('messagesPage', {
    template: template,
    bindings: {
        policyIndex: '<',
        policyInfo: '<'
    },
    controller: function(this: MessagesPageController) {}
});

export { module };
